import React from 'react'
import { blogStatusOptions } from '../BlogStatusOptions'
import { Select } from '@ztechapps/webui.input'

export const BlogStatusSelect = ({ ...rest }: any) => {
  return (
    <Select
      {...{
        ...rest,
        options: blogStatusOptions,
      }}
    />
  )
}
